module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listTitle": "Produtos aguardando match",
      "listLogo": _vm.moduleDefinition.logo,
      "filterTitle": "Listagem de produtos",
      "loading": _vm.loading,
      "total": _vm.total,
      "sortFields": ['title'],
      "sortDefault": {
        field: 'title',
        order: 'asc'
      }
    },
    on: {
      "change": _vm.onChange,
      "loadMore": _vm.loadMore
    }
  }, [_c('div', {
    attrs: {
      "slot": "top-actions"
    },
    slot: "top-actions"
  }), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Código do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.code),
      expression: "options.code"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "EAN do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.ean),
      expression: "options.ean"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.ean)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "ean", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Título do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.title),
      expression: "options.title"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Marca"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.brand),
      expression: "options.brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand,
      domProps: {
        "value": brand
      }
    }, [_vm._v(_vm._s(brand))])
  })], 2)])], 1), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return (_vm.products.length) ? _c('div', {
      key: product,
      staticClass: "l-col-12@md"
    }, [(product.status === 'match') ? _c('product-match-card', {
      attrs: {
        "product": product
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "l-col u-textCenter"
    }, [_c('panel', [_vm._v("Nenhum produto encontrado.")])], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f619df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductMatch/List.vue
// module id = 3003
// module chunks = 0